import { Phone } from "lucide-react";

export const MobileFloatingCTA = () => {
  return (
    <a
      href="tel:+1-771-1871-987"
      className="floating-cta bg-emerald-600 text-white p-4 rounded-full shadow-2xl hover:bg-emerald-700 transition-all duration-300 hover:scale-110"
      data-testid="mobile-floating-cta"
      aria-label="Call Nexivas"
    >
      <Phone className="w-6 h-6" />
    </a>
  );
};
